import {Component, Input, OnInit} from '@angular/core';
import {AutoUnsubscribe} from '../../../../../infrastructure/decorators/auto-unsubscribe.decorator';
import {AzureAuthService} from '../../../../../infrastructure/services/azure-auth.service';

@AutoUnsubscribe()
@Component({
    selector: 'app-booking-template.layout',
    templateUrl: './booking-template.layout.component.html',
    standalone: false
})
export class BookingTemplateLayoutComponent implements OnInit {
  @Input() public data: any;
  templateData: any;
  flag: number = 1;
  update: number = 0;
  isUserLoggedIn: boolean = false;

  constructor(private azureAuthService: AzureAuthService) {
  }

  ngOnInit(): void {
    this.azureAuthService.isUserLoggedIn.subscribe(x => {
      this.isUserLoggedIn = x;
    })
  }

  getSelectedTemplateInfo(data: any) {
    this.templateData = data;
  }
}
